/**
 * Get the appropriate map marker icon based on vehicle type
 * @param {string} vehicleType - The vehicle type (bike, scooter, car, sedan, hatchback, suv)
 * @returns {Object} Icon configuration object for Google Maps
 */
export const getVehicleIcon = (vehicleType) => {
  if (!vehicleType) {
    // Default to bike icon if no vehicle type
    return {
      url: 'https://maps.google.com/mapfiles/ms/icons/motorcycling.png',
      scaledSize: { width: 40, height: 40 },
      anchor: { x: 20, y: 20 }
    };
  }

  const vehicleTypeLower = vehicleType.toLowerCase();
  
  // Two-wheelers: bike, scooter
  if (vehicleTypeLower === 'bike' || vehicleTypeLower === 'scooter') {
    return {
      url: 'https://maps.google.com/mapfiles/ms/icons/motorcycling.png',
      scaledSize: { width: 40, height: 40 },
      anchor: { x: 20, y: 20 }
    };
  }
  
  // Four-wheelers: car, sedan, hatchback, suv
  if (['car', 'sedan', 'hatchback', 'suv'].includes(vehicleTypeLower)) {
    // Use taxi/cab icon for cars (Google Maps doesn't have a standard car icon)
    return {
      url: 'https://maps.google.com/mapfiles/ms/icons/cabs.png',
      scaledSize: { width: 40, height: 40 },
      anchor: { x: 20, y: 20 }
    };
  }
  
  // Default fallback to bike icon
  return {
    url: 'https://maps.google.com/mapfiles/ms/icons/motorcycling.png',
    scaledSize: { width: 40, height: 40 },
    anchor: { x: 20, y: 20 }
  };
};

/**
 * Get vehicle label for display
 * @param {string} vehicleType - The vehicle type
 * @returns {string} Formatted vehicle label
 */
export const getVehicleLabel = (vehicleType) => {
  if (!vehicleType) return '';
  return vehicleType.charAt(0).toUpperCase() + vehicleType.slice(1);
};

